/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_X_Move_LeftInputs */

const en_input_position_x_move_left = /** @type {(inputs: Input_Position_X_Move_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move Left 1 Character`)
};

const fr_input_position_x_move_left = /** @type {(inputs: Input_Position_X_Move_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déplacer à Gauche de 1 Caractère`)
};

const de_input_position_x_move_left = /** @type {(inputs: Input_Position_X_Move_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewege dich um 1 Zeichen nach links`)
};

const it_input_position_x_move_left = /** @type {(inputs: Input_Position_X_Move_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta a sinistra di 1 carattere`)
};

const ru_input_position_x_move_left = /** @type {(inputs: Input_Position_X_Move_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переместить влево на 1 символ`)
};

const es_input_position_x_move_left = /** @type {(inputs: Input_Position_X_Move_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover 1 carácter a la izquierda`)
};

const zh_cn2_input_position_x_move_left = /** @type {(inputs: Input_Position_X_Move_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向左移动 1 个字符`)
};

const ja_input_position_x_move_left = /** @type {(inputs: Input_Position_X_Move_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1文字左に移動`)
};

const hi_input_position_x_move_left = /** @type {(inputs: Input_Position_X_Move_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाईं ओर 1 अक्षर खिसकाएँ`)
};

const pt_pt2_input_position_x_move_left = /** @type {(inputs: Input_Position_X_Move_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover 1 caractere para a esquerda`)
};

/**
* | output |
* | --- |
* | "Move Left 1 Character" |
*
* @param {Input_Position_X_Move_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_x_move_left = /** @type {((inputs?: Input_Position_X_Move_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_X_Move_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_x_move_left(inputs)
	if (locale === "de") return de_input_position_x_move_left(inputs)
	if (locale === "it") return it_input_position_x_move_left(inputs)
	if (locale === "ru") return ru_input_position_x_move_left(inputs)
	if (locale === "es") return es_input_position_x_move_left(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_x_move_left(inputs)
	if (locale === "ja") return ja_input_position_x_move_left(inputs)
	if (locale === "hi") return hi_input_position_x_move_left(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_x_move_left(inputs)
	return en_input_position_x_move_left(inputs)
});